import { render, staticRenderFns } from "./PrepareSelfie.vue?vue&type=template&id=f8fd19f2&"
import script from "./PrepareSelfie.vue?vue&type=script&lang=ts&"
export * from "./PrepareSelfie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports